import { type SerializeFrom } from '@cx-web/domain-types';
import { type DehydratedState } from '@tanstack/react-query';

// A dehydrated React Query cache is "invalid" for rendering when it has no queries or every query
// resolved to null data — the same predicate RR7 uses (app/utils/invalidDehydratedState.ts). Co-located
// here so the shared GridGroup component has no host dependency. See tidy-up backlog (NGF-6507): promote
// to @cx-web/utils and dedupe with the RR7 copy.
export function invalidDehydratedState(
  dehydratedState: DehydratedState | null | undefined | SerializeFrom<DehydratedState | null>,
): dehydratedState is DehydratedState {
  return (
    (dehydratedState &&
      (dehydratedState.queries.length === 0 || dehydratedState.queries.every(query => query.state.data === null))) ||
    false
  );
}
